import Vue, { Promise } from 'vue'
import VR from 'vue-resource'

Vue.use(VR)

function generateCallId () { // call UID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : r & 0x3 | 0x8
    return v.toString(16)
  })
}

const callerPromisePool = {}
const eventHandler = {}
let beforeWsOpenMessages = []

export default class {
  constructor (url) {
    this.ws = new window.WebSocket(url, 'intri')
    this.ws.onopen = () => {
      console.log('ws rpc opened')
      for (let { uuid, wsMessage } of beforeWsOpenMessages) {
        this.wsSendWithTimeoutRetry(uuid, wsMessage)
      }
      beforeWsOpenMessages = []
    }
    this.ws.onclose = (e) => {
      console.log('ws rpc close', e)
      window.location.reload(true)
    }
    this.ws.onerror = error => console.log('ws error', error)
    this.ws.onmessage = msg => {
      let o = JSON.parse(msg.data)
      if (!o.jsonrpc) return
      this.handleMessage(o)
    }
  }
  handleMessage (msg) {
    if (msg.result && msg.id) {
      if (callerPromisePool[msg.id]) {
        callerPromisePool[msg.id].resolve(msg.result)
        delete callerPromisePool[msg.id]
      } else {
        console.log(`got call return but ${msg.id} not in pool`)
      }
    } else if (msg.method) {
      if (eventHandler[msg.method]) {
        eventHandler[msg.method](msg.params)
      } else {
        console.log(`received unsubscribed event ${msg.method}`)
      }
    } else {
      console.log('unknow format received message', msg)
    }
  }
  subscribe (eventName, func) {
    if (typeof func === 'function') eventHandler[eventName] = func
  }
  call (devid, method, params = {}) {
    return new Promise((resolve, reject) => {
      if (typeof devid !== 'string') reject('rpc caller must have a device id')
      if (typeof method !== 'string') reject('rpc caller must have a method')
      let uuid = generateCallId()
      let message = {
        jsonrpc: '2.0',
        method,
        params: {
          ...params,
          version: '0',
          deviceId: devid
        },
        id: uuid
      }
      let wsMessage = JSON.stringify(message)
      callerPromisePool[uuid] = {
        resolve,
        reject,
        wsMessage
      }
      if (this.ws.readyState) {
        this.wsSendWithTimeoutRetry(uuid, wsMessage)
      } else {
        beforeWsOpenMessages.push({
          uuid,
          wsMessage
        })
      }
    })
  }
  wsSendWithTimeoutRetry (uuid, wsMessage, counter = 0) {
    this.ws.send(wsMessage)
    setTimeout(() => {
      if (callerPromisePool[uuid]) {
        if (counter < 5) this.wsSendWithTimeoutRetry(uuid, wsMessage, counter + 1)
        else {
          callerPromisePool[uuid].reject('Device no response.')
          delete callerPromisePool[uuid]
        }
      }
    }, 5000)
  }
}



// WEBPACK FOOTER //
// ./src/Rpc.js